<template>
  <div class="c-go-back" :class="{'withCoins': needCoinsBlock}">
    <div class="wrap">
      <n-link :to="{name: backroute}">
        <div class="back-row">
          <img :src="imgBacrow" alt="">
        </div>
      </n-link>
      <h1 class="title" :class="{'withoutCoins': notNeedCoins}">{{ title }}</h1>
      <div>
        <n-link v-if="!notNeedCoins" class="coins-block" :to="{name: 'myBonuses'}">
          <p>{{ $app.auth.user().points }}</p>
          <img :src="imgMcCoin" alt="">
        </n-link>
      </div>
    </div>

  </div>
</template>

<script>
import imgBacrow from 'assets/rows/bacrow.svg'
import imgMcCoin from 'assets/main/shop/new-mc-coin.svg'

export default {
  name: 'CGoBack',
  props: {
    backroute: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    needCoinsBlock: {
      type: Boolean,
      default: false,
    },
    notNeedCoins: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imgBacrow,
      imgMcCoin,
    }
  },
}
</script>

<style lang="scss" scoped>

.c-go-back {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1000;
  padding: calc(env(safe-area-inset-top) + 10px) 20px 10px 20px;
  background-color: #fafafa;
  .title {
    font-size: 16px;
  }

  &.withCoins {
    justify-content: space-between;
  }

  .wrap {
    padding: 5px 10px;
    background-color: #F5EEE5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 10px;
  }

  .back-row {
  }
  h1 {
    font-size: 1.3em;
    color: var(--secondary);
    margin-left: 70px;
    &.withoutCoins {
      margin: 0 auto;
    }
  }
  .coins-block {
    min-width: 84px;
    margin-right: 10px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-radius: 12px;


    &.hidden {
      display: none;
    }

    p {

      font-size: 1.2em;
    }
    img {
      margin-left: 5px;
      width: 18px;
      height: 18px;
    }
  }
}
</style>
